import type { ButtonTypes } from "@/components/button";

export const ISSUE_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "3d-error", label: "3D error" },
  { value: "anatomical-error", label: "Anatomical error" },
] as const;

export const ISSUE_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export const ISSUE_STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "unread", label: "Unread" },
  { value: "read", label: "Read" },
] as const;

export type IssueType = "3d-error" | "anatomical-error";
export type IssueTypeFilter = (typeof ISSUE_TAB_ITEMS)[number]["value"];
export type IssuePeriod = (typeof ISSUE_PERIOD_OPTIONS)[number]["value"];
export type IssueStatus = (typeof ISSUE_STATUS_OPTIONS)[number]["value"];

type BadgeVariant = NonNullable<ButtonTypes["variant"]>;

const ISSUE_TYPE_META: Record<IssueType, { label: string; variant: BadgeVariant }> = {
  "3d-error": {
    label: "3D error",
    variant: "warning",
  },
  "anatomical-error": {
    label: "Anatomical error",
    variant: "danger",
  },
};

export const getIssueTypeMeta = (type: IssueType) => ISSUE_TYPE_META[type];

export const formatIssueTimestamp = (timestamp: number) =>
  new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(timestamp));
